import Vue from 'vue';
import VueResource from 'vue-resource';
import App from './App.vue';

Vue.use(VueResource);
//Vue.http.options.root = 'http://localhost:8080/index.php/v1/';
Vue.http.options.root = 'https://api.ludotheque-savenay.fr/v1/';

/*
    Converti les minutes en chaine à afficher,
    exemple: 90 -> "1h30"
*/
Vue.filter('dureeAffichage', function (duree) {
    if (!duree) return ''

    duree = parseInt(duree);
    if (duree < 60) {
        return duree + ' min';
    } else {
        let heures = Math.floor(duree / 60);
        let minutes = duree - (heures * 60);
        if (minutes > 0) {
            return heures + 'h' + minutes;
        } else {
            return heures + ' h';
        }
    }
})


new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js